import React from "react";
import BannerMoc from "../assets/images/mocs/banner-moc-1-1.png";
const Banner = () => {
  return (
    <section className="banner-one" id="banner">
      <span className="banner-one__shape-1"></span>
      <span className="banner-one__shape-2"></span>
      <span className="banner-one__shape-3"></span>
      <span className="banner-one__shape-4"></span>
      <div className="container">
        <div className="banner-one__moc">
          <img src={BannerMoc} alt="alter text" />
        </div>
        <div className="row">
          <div className="col-xl-6 col-lg-8">
            <div className="banner-one__content">
              <h3 className="banner-one__title">
                We Deliver the <br />
                <span>Dental Software & Apps</span> you Need.
              </h3>
              <p className="banner-one__text">
                Partners in providing software and app solutions to dentists, dental practices and DSO's. Just let us know what problem you are facing and we will solve it for you!<br />{" "}
              </p>
              <a href="mailto:${hello@leadplotter.com}" className="banner-one__btn thm-btn ">
                <span>What do you Need Help With?</span>
              </a>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};
export default Banner;
